import React from 'react';
import './contact-us.css';


const MIN_TIME_BETWEEN_REQUESTS = 3000;
const MAX_MESSAGE_LENGTH = 2500;
const MAX_LINKS_PER_MESSAGE = 3;

export default class ContactUs extends React.Component {
   
  constructor(props) {
    super(props);
    this.serviceApi = props.serviceApi;
    this.state = {
      serviceApi: props.serviceApi, 
      email: '',
      name: '',
      message: '',
      honeypot: '',
      mountedAt: Date.now(),
      showMessage: false,
      sending: false,
      error: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    const target = event.target;
    const name = target.name;
    const value = this._getValueFromInput(target);

    this.setState({
      [name]: value
    });
  }

  countLinks(message) {
    return (message.match(/(https?:\/\/[^\s]+)/g) || []).length;
  }

  handleSubmit(event) {
    const serviceApi = this.serviceApi;
    const { name, message, email, honeypot, mountedAt } = this.state;

    if(honeypot) {
      this.setState({
        error: false,
      });
      return;
    }

    if(Date.now() - mountedAt < MIN_TIME_BETWEEN_REQUESTS) {
      this.setState({
        error: false,
      });
      return;
    }

    if(this.countLinks(message) > MAX_LINKS_PER_MESSAGE) {
      this.setState({
        error: true
      });
      return;
    }

    if(message.length > MAX_MESSAGE_LENGTH) {
      this.setState({
        error: true
      });
      return;
    }

    this.setState({
      showMessage: true,
      sending: true
    });

    fetch(serviceApi, {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        name,
        email,
        message,
        domain: 'duquebandaasociados.com',
        createdAt: new Date().toISOString(),
        status: 0,
        honeypot
      })
    }).then(response => {
      if(response.status === 200) {
        this.setState({
          email: '',
          name: '',
          message: '',
          honeypot: '',
          mountedAt: Date.now(),
          showMessage: false,
          sending: false,
          error: false
        });  
      } else {
        this.setState({
          error: true
        }); 
      }
    }).catch(error => {
      this.setState({
        error: true
      });
    });

    event.preventDefault();
  }

  _getValueFromInput(target) {
    if(!target){
      return null;
    } else if(target.type === 'checkbox') {
      return target.checked;
    } else {
      return target.value;
    }
  }

  _printMessage() {
    if(!this.state.showMessage) {
      return (<div></div>);
    } else if(this.state.error) {
      return (<div className="message error">Lo Sentimos algo salió mal, intentalo más tarde</div>);
    } else if(this.state.sending) {
      return (<div className="message sending">Enviando...</div>);
    } else {
      return (<div className="message success"> Hemos recibido tu mensaje.</div>);
    }
  }

  render() {
    const showMessage = this.state.showMessage;
    return(
      <div className="form-container">
        {this._printMessage()}
        <form onSubmit={this.handleSubmit}>
          
          <label>E-mail:</label>
          <input type="email" 
            name="email" 
            value={this.state.email} 
            onChange={this.handleChange}
            required
            placeholder="example@mail.com"/>
          
          <label>Nombre:</label>
            <input type="text" 
              name="name" 
              value={this.state.name} 
              onChange={this.handleChange}
              required 
              placeholder="Juan Peréz"/>

          <label>Mensaje:</label>
          <textarea 
            name="message" 
            value={this.state.message} 
            onChange={this.handleChange}
            rows="5" 
            cols="50" required
            placeholder="Mensaje"/>
          <label style={{display: "none"}}>Honeypot: </label>
          <input type="text" name="honeypot" value={this.state.honeypot} onChange={this.handleChange} style={{display: 'none'}}/>
          <input type="submit" value="Enviar" disabled={showMessage} />
        </form>
      </div>  
    );
  }
}

